/**
 * Player Intervention Reducers
 */
import {
    PLAYERINTERVENTION_ACTION,
    FETCH_PLAYERINTERVENTION,
    FETCH_PLAYERTECHSAMLAB,
    FETCH_PLAYERTECHCAPTO,
    FETCH_PLAYERTECHLAUNCH,
    FETCH_PLAYERTECHHACK,
    FETCH_PLAYERTECHFSIRON,
    FETCH_PLAYERTECHFSDRIVER,
    FETCH_PLAYERTECHWEDGE,
    FETCH_PLAYERTECHCOURSE,
    FETCH_PLAYERTECHSPEED,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    playerinterventionlist:[],
    playertechsamlab:[],
    playertechcapto:[],
    playertechlaunch:[],
    playertechhack:[],
    playertechfsiron:[],
    playertechfsdriver:[],
    playertechwedge:[],
    playertechcourse:[],
    playertechspeed:{ label: [], clubspeed: [], ballspeed: [], carry: [] },
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case PLAYERINTERVENTION_ACTION:
            return { ...state, loading: true };
 
        case FETCH_PLAYERINTERVENTION:
            return { ...state, loading: false, playerinterventionlist: action.payload };  
            
        case FETCH_PLAYERTECHSAMLAB:
            return { ...state, loading: false, playertechsamlab: action.payload }; 
            
        case FETCH_PLAYERTECHCAPTO:
            return { ...state, loading: false, playertechcapto: action.payload }; 

        case FETCH_PLAYERTECHLAUNCH:
            return { ...state, loading: false, playertechlaunch: action.payload };
            
        case FETCH_PLAYERTECHHACK:
            return { ...state, loading: false, playertechhack: action.payload };

        case FETCH_PLAYERTECHFSIRON:
            return { ...state, loading: false, playertechfsiron: action.payload };  
            
        case FETCH_PLAYERTECHFSDRIVER:
            return { ...state, loading: false, playertechfsdriver: action.payload };  

        case FETCH_PLAYERTECHWEDGE:
            return { ...state, loading: false, playertechwedge: action.payload };  

        case FETCH_PLAYERTECHCOURSE:
            return { ...state, loading: false, playertechcourse: action.payload };  

        case FETCH_PLAYERTECHSPEED:
            return {
                ...state,
                loading: false,
                playertechspeed: action.payload && !Array.isArray(action.payload)
                    ? action.payload
                    : { label: [], clubspeed: [], ballspeed: [], carry: [] },
            };  
        
         default: return { ...state };
     }
 }